module.exports = __webpack_public_path__ + "static/media/avatar39.5cf4aa9b.png";